const items = [
  {
    id: 1,
    name: "Backpack",
    pictureClass: "sprite4 pexels-matheus-bertelli-2905238",
    price: 82,
    quantity: 1,
  },
  {
    id: 2,
    name: "Basketball Shoes",
    pictureClass: "sprite4 pexels-amar-preciado-9993287",
    price: 145,
    quantity: 1,
  },
  {
    id: 3,
    name: "Vintage Game Console",
    pictureClass: "sprite4 pexels-andrew-varnum-13743558",
    price: 93,
    quantity: 1,
  },
  {
    id: 4,
    name: "Mobile Game Console",
    pictureClass: "sprite4 pexels-dids-1367036",
    price: 198,
    quantity: 1,
  },
  {
    id: 5,
    name: "Luggage Set",
    pictureClass: "sprite4 pexels-dids-1986996",
    price: 166,
    quantity: 1,
  },
  {
    id: 6,
    name: "Makeup Brushes",
    pictureClass: "sprite4 pexels-kinkate-gruber-205923",
    price: 24,
    quantity: 1,
  },
  {
    id: 7,
    name: "Laptop",
    pictureClass: "sprite4 pexels-life-of-pix-7974",
    price: 480,
    quantity: 1,
  },
  {
    id: 8,
    name: "Lipstick Kit",
    pictureClass: "sprite4 pexels-suzy-hazelwood-2533266",
    price: 21,
    quantity: 1,
  },
  {
    id: 9,
    name: "Comfortable Shoes",
    pictureClass: "sprite4 pexels-luis-quintero-14174472",
    price: 220,
    quantity: 1,
  },
  {
    id: 10,
    name: "Diamond Bracelet",
    pictureClass: "sprite4 pexels-pixabay-266621",
    price: 270,
    quantity: 1,
  },
  {
    id: 11,
    name: "Fur Jacket",
    pictureClass: "sprite4 pexels-evg-kowalievska-1040173",
    price: 86,
    quantity: 1,
  },
  {
    id: 12,
    name: "Women's Blazer",
    pictureClass: "sprite4 pexels-godisable-jacob-794062",
    price: 119,
    quantity: 1,
  },
  {
    id: 13,
    name: "Golf Clubs",
    pictureClass: "sprite4 pexels-kindel-media-6573713",
    price: 230,
    quantity: 1,
  },
  {
    id: 14,
    name: "Books",
    pictureClass: "sprite4 pexels-anthony--158834",
    price: 39,
    quantity: 1,
  },
  {
    id: 15,
    name: "Tie",
    pictureClass: "sprite4 pexels-dom-j-45055",
    price: 44,
    quantity: 1,
  },
  {
    id: 16,
    name: "Sweater",
    pictureClass: "sprite4 pexels-dom-j-45982",
    price: 65,
    quantity: 1,
  },
  {
    id: 17,
    name: "Silver Watch",
    pictureClass: "sprite4 pexels-fernando-arcos-190819",
    price: 430,
    quantity: 1,
  },
  {
    id: 18,
    name: "Running Shoes",
    pictureClass: "sprite4 pexels-shane-aldendorff-786003",
    price: 95,
    quantity: 1,
  },
  {
    id: 19,
    name: "Dog Book",
    pictureClass: "sprite4 pexels-lisa-fotios-880720",
    price: 13,
    quantity: 1,
  },
  {
    id: 20,
    name: "Tennis Shoes",
    pictureClass: "sprite4 pexels-kaique-rocha-90365",
    price: 112,
    quantity: 1,
  },
  {
    id: 21,
    name: "Lamb Sweater",
    pictureClass: "sprite4 pexels-kat-smith-568022",
    price: 27,
    quantity: 1,
  },
  {
    id: 22,
    name: "Golf Wedges",
    pictureClass: "sprite4 pexels-kindel-media-6573691",
    price: 170,
    quantity: 1,
  },
  {
    id: 23,
    name: "Makeup Kit",
    pictureClass: "sprite4 pexels-kinkate-gruber-212236",
    price: 25,
    quantity: 1,
  },
  {
    id: 24,
    name: "Blue Watch",
    pictureClass: "sprite4 pexels-joey-nguyn-2113994",
    price: 388,
    quantity: 1,
  },
  {
    id: 25,
    name: "Dress Shoes",
    pictureClass: "sprite4 pexels-lukas-292999",
    price: 190,
    quantity: 1,
  },
  {
    id: 26,
    name: "Outdoor Cap",
    pictureClass: "sprite4 pexels-marcus-murphy-1878821",
    price: 47,
    quantity: 1,
  },
  {
    id: 27,
    name: "Skateboard",
    pictureClass: "sprite4 pexels-messala-ciulla-1018484",
    price: 88,
    quantity: 1,
  },
  {
    id: 28,
    name: "Outdoor Outfit",
    pictureClass: "sprite4 pexels-kristina-paukshtite-704805",
    price: 93,
    quantity: 1,
  },
  {
    id: 29,
    name: "Adventure Book",
    pictureClass: "sprite4 pexels-mark-neal-2954199",
    price: 17,
    quantity: 1,
  },
  {
    id: 30,
    name: "Hiking Backpack",
    pictureClass: "sprite4 pexels-ravindra-rawat-1294731",
    price: 92,
    quantity: 1,
  },
  {
    id: 31,
    name: "Wallet",
    pictureClass: "sprite4 pexels-robert-bogdan-910122",
    price: 19,
    quantity: 1,
  },
  {
    id: 32,
    name: "Charm Bracelet",
    pictureClass: "sprite4 pexels-godisable-jacob-1191536",
    price: 77,
    quantity: 1,
  },
  {
    id: 33,
    name: "Water Bottle",
    pictureClass: "sprite4 pexels-luis-quintero-4000090",
    price: 31,
    quantity: 1,
  },
  {
    id: 34,
    name: "Low Top Shoes",
    pictureClass: "sprite4 pexels-aman-jakhar-2048548",
    price: 89,
    quantity: 1,
  },
  {
    id: 35,
    name: "High Top Shoes",
    pictureClass: "sprite4 pexels-mnz-1598505",
    price: 146,
    quantity: 1,
  },
  {
    id: 36,
    name: "Casual Outfit",
    pictureClass: "sprite4 pexels-mnz-1670770",
    price: 112,
    quantity: 1,
  },
  {
    id: 37,
    name: "Cellphone",
    pictureClass: "sprite4 pexels-mohi-syed-47261",
    price: 374,
    quantity: 1,
  },
  {
    id: 38,
    name: "Blender",
    pictureClass: "sprite4 pexels-nicola-barts-7936980",
    price: 58,
    quantity: 1,
  },
  {
    id: 39,
    name: "Book Series",
    pictureClass: "sprite4 pexels-pixabay-48020",
    price: 55,
    quantity: 1,
  },
  {
    id: 40,
    name: "Fresh Groceries",
    pictureClass: "sprite4 pexels-pixabay-264636",
    price: 27,
    quantity: 1,
  },
  {
    id: 41,
    name: "String Bracelet",
    pictureClass: "sprite4 pexels-pixabay-371285",
    price: 8,
    quantity: 1,
  },
];

export function getItems() {
  return items;
}
